namespace $ {

	$mol_style_attach( '$shm_agent_media_popover', `
		[shm_agent_media_bubble] {
			inset: 0 !important;
			width: 100vw !important;
			height: 100dvh !important;
			max-width: none !important;
			max-height: none !important;
			margin: 0 !important;
			border-radius: 0 !important;
			transform: none !important;
			background: transparent !important;
		}
	` )

	$mol_style_define( $shm_agent_media, {
		Preview: {
			cursor: 'zoom-in',
			width: '10rem',
			height: '10rem',
			maxWidth: '100%',
			padding: 0,
			overflow: 'hidden',
			border: { radius: $mol_gap.round },
			background: { color: $mol_theme.hover },
		},
		Preview_image: {
			width: '100%',
			height: '100%',
			objectFit: 'contain',
		},
		Preview_video: {
			width: '100%',
			height: '100%',
			objectFit: 'contain',
			pointerEvents: 'none',
		},
		Overlay: {
			cursor: 'zoom-out',
			position: 'relative',
			width: '100%',
			height: '100%',
			align: { items: 'center' },
			justifyContent: 'center',
			padding: $mol_gap.block,
			background: { color: '#000000d9' },
		},
		Full: {
			width: '100%',
			height: '100%',
			align: { items: 'center' },
			justifyContent: 'center',
			background: { color: 'transparent' },
		},
		Full_image: {
			maxWidth: '100%',
			maxHeight: '100%',
			width: 'auto',
			height: 'auto',
			objectFit: 'contain',
		},
		Full_video: {
			maxWidth: '100%',
			maxHeight: '100%',
			width: 'auto',
			height: 'auto',
		},
		Close: {
			position: 'absolute',
			top: $mol_gap.block,
			right: $mol_gap.block,
			color: $mol_theme.text,
			background: { color: $mol_theme.card },
		},
	} )

}
